<template>
  <a
    class="m-banner-item"
    :href="banner.href"
    :aria-label="banner.name"
    @click="handleClick"
  >
    <ImageContainer
      :ratio="1/3"
      watermark
      :src="banner.image"
      :alt="banner.name || ''"
    >
      <img
        :src="banner.image"
        :alt="banner.name || ''"
        :loading="order > 0 ? 'lazy' : ''"
      >
    </ImageContainer>

  </a>
</template>

<script>
import ImageContainer from '@ms/components/ImageContainer.vue'

export default {
  components: {
    ImageContainer
  },
  props: {
    banner: {
      type: Object,
      default: () => ({})
    },
    source: {
      type: String,
      default: ''
    },
    order: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const handleClick = () => {
      window.mstrace(`${props.source}_Banner${props.order}`)
    }

    return {
      handleClick
    }
  }
}
</script>

<style lang="less" scoped>
.m-banner-item {
  display: block;
}
</style>
